import createReducer from 'utils/redux/createReducer'

const initialState = {}

export default createReducer(initialState, {
    SCROLL: (currentState, action) => {
        return {...currentState, [action.data.name]: action.data.scrollTop}
    }
})



// WEBPACK FOOTER //
// ./src/reducers/scrollTop.js